export const anylineStates = {
    DISPOSED: 'disposed',
    INITALIZED: "initalized",
    PAUSED: "paused",
    SCANNING: "scanning",
    STOPPED: "stopped",
}